import React, { useState, useEffect } from "react";
import "./Contact";

import { FaFacebookF } from "react-icons/fa";
import { FiInstagram } from "react-icons/fi";
import { RiTwitterXLine } from "react-icons/ri";
import { FaLinkedin } from "react-icons/fa6";
import { MdPhone, MdEmail, MdLocationOn } from "react-icons/md";

import Linkedin from "./Assets/Linkedin.png";
import Twitter from "./Assets/Twitter.png";
import Instagram from "./Assets/Instagram.png";
import Facebook from "./Assets/Facebook.png";

import Game from "./Assets/ContactPage.gif";
import GameStatic from "./Assets/ContactPage.gif"; 
import logo from "./Assets/scroll.png";

const Contact = () => {
  const [visible, setVisible] = useState(false);
  const [showGame, setShowGame] = useState(true);
  const [gameSrc, setGameSrc] = useState("");

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);


  useEffect(() => {
    const animatedUrl = `${Game}?v=${Date.now()}`;
    setGameSrc(animatedUrl);

    const timer = setTimeout(() => {
      setShowGame(false);
    }, 3000); 

    return () => clearTimeout(timer);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <section className="contact-container" id="contact">
      <div className="contact-grid">
        {/* Left Side */}
        <div className="left-side">
          {/* One-time animated Game banner */}
          {showGame ? (
            <img src={gameSrc} alt="Follow Banner" className="follow-banner" />
          ) : (
            <img
              src={GameStatic}
              alt="Follow Banner"
              className="follow-banner"
            />
          )}

          <h2>Where to find us?</h2>
          <p>
            <MdLocationOn className="contact-icon" /> #226, Fusion Hub, <br />
            Kamaraj Nagar, Ariyur road, Thorapadi, <br />
            Vellore, Tamil Nadu, India - 632002
          </p>

          <h2 className="follow">Follow Us</h2>
          <div className="social-icons">
            <div className="icon-block">
              <FaLinkedin className="icon" />
              <img src={Linkedin} alt="Linkedin" />
            </div>
            <div className="icon-block">
              <FiInstagram className="icon" />
              <img src={Instagram} alt="Instagram" />
            </div>
            <div className="icon-block">
              <FaFacebookF className="icon" />
              <img src={Facebook} alt="Facebook" />
            </div>
            <div className="icon-block">
              <RiTwitterXLine className="icon" />
              <img src={Twitter} alt="Twitter" />
            </div>
          </div>
        </div>

        {/* Right Side */}
        <div className="right-side contact-info">
          <h2>Want solutions?</h2>
          <p>
            <MdEmail className="contact-icon" /> &nbsp;
            letstalkbusiness@heartintech.solutions
          </p>
          <p>
            <MdPhone className="contact-icon" />
            &nbsp; +91-416-2998394
          </p>

          <h2>Want to be a heartian?</h2>
          <p>
            <MdEmail className="contact-icon" /> &nbsp;
            careers@heartintech.solutions
          </p>

          <div className="map-container">
            <iframe
              title="Heartin Tech Location"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d243.08409995933283!2d79.11629996972368!3d12.885484897670496!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6d60bbf38330d9f9%3A0xd21030c3bf4b628a!2sheartin%20tech%20-%20the%20solutions%20company!5e0!3m2!1sen!2sin!4v1747210407797!5m2!1sen!2sin"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
        
      </div>

      {/* Scroll Btn */}
      <button
        className={`scroll-btn ${visible ? "visible" : ""}`}
        onClick={scrollToTop}
        aria-label="Scroll to top"
      >
        <img src={logo} alt="Up arrow" className="scroll-icon" />
      </button>
    </section>
  );
};

export default Contact;
